import { apiClient } from '@/shared/lib/apiClient';
import type {
  AdminTrialItem,
  AdminTrialsListResponse,
  CancelAdminTrialBody,
  ExtendAdminTrialBody,
  ListAdminTrialsQuery,
  ResumeAdminTrialBody,
  SuspendAdminTrialBody,
} from '../types/adminTrial';

interface ApiResponse<T> {
  success: boolean;
  data: T;
}

export async function listAdminTrials(
  query?: ListAdminTrialsQuery,
): Promise<AdminTrialsListResponse> {
  const params: Record<string, string> = {};
  if (query?.cursor) params['cursor'] = query.cursor;
  if (query?.limit !== undefined) params['limit'] = String(query.limit);
  if (query?.status) params['status'] = query.status;
  if (query?.product_id) params['product_id'] = query.product_id;
  if (query?.product_slug) params['product_slug'] = query.product_slug;
  if (query?.plan_id) params['plan_id'] = query.plan_id;
  if (query?.tenant_id) params['tenant_id'] = query.tenant_id;
  if (query?.search) params['search'] = query.search;
  if (query?.expiring_soon_days !== undefined) {
    params['expiring_soon_days'] = String(query.expiring_soon_days);
  }
  if (query?.from) params['from'] = query.from;
  if (query?.to) params['to'] = query.to;

  const res = await apiClient.get<ApiResponse<AdminTrialsListResponse>>('/api/v1/admin/trials', {
    params,
  });
  return res.data;
}

export async function extendAdminTrial(
  subscriptionId: string,
  body: ExtendAdminTrialBody,
): Promise<AdminTrialItem> {
  const res = await apiClient.post<ApiResponse<AdminTrialItem>>(
    `/api/v1/admin/trials/${subscriptionId}/extend`,
    body,
  );
  return res.data;
}

export async function cancelAdminTrial(
  subscriptionId: string,
  body: CancelAdminTrialBody,
): Promise<AdminTrialItem> {
  const res = await apiClient.post<ApiResponse<AdminTrialItem>>(
    `/api/v1/admin/trials/${subscriptionId}/cancel`,
    body,
  );
  return res.data;
}

export async function suspendAdminTrial(
  subscriptionId: string,
  body: SuspendAdminTrialBody,
): Promise<AdminTrialItem> {
  const res = await apiClient.post<ApiResponse<AdminTrialItem>>(
    `/api/v1/admin/trials/${subscriptionId}/suspend`,
    body,
  );
  return res.data;
}

export async function resumeAdminTrial(
  subscriptionId: string,
  body: ResumeAdminTrialBody,
): Promise<AdminTrialItem> {
  const res = await apiClient.post<ApiResponse<AdminTrialItem>>(
    `/api/v1/admin/trials/${subscriptionId}/resume`,
    body,
  );
  return res.data;
}
